import React from 'react';
import { Form } from 'react-bootstrap';
import DropDownComponent from '../utils/dropDown';
import { isItalicOrNormal } from '../editor/editorExtensions/utilityFunctions';

interface FontFamilyComponentInterface {
  setFontProperty: Function;
  fontPropertyValue: string;
  componentType: string;
  options: {};
  customFonts?: FontObject[];
  setFontStyle?: Function;
  fontStyleValue?: string;
}
interface FontObject {
  fontFamily: string;
  name: string;
  url?: string;
  fontStyle?: string;
}

const FontHandlerComponent = (props: FontFamilyComponentInterface) => {
  const {
    setFontProperty,
    fontPropertyValue,
    componentType,
    options,
    customFonts,
    setFontStyle,
    fontStyleValue,
  } = props;
  let combinedFonts: { [key: string]: string } = {};
  if (componentType === 'Font Family') {
    if (customFonts) {
      for (let fonts of customFonts) {
        const displayName = fonts.fontStyle ? `${fonts.name}-${fonts.fontStyle}` : fonts.name;
        const finalValue = fonts.fontStyle
          ? `${fonts.fontFamily}-${fonts.fontStyle}`
          : `${fonts.fontFamily}`;

        combinedFonts[displayName] = finalValue;
      }
    }
    combinedFonts = { ...options, ...combinedFonts };
    // eslint-disable-next-line @typescript-eslint/require-array-sort-compare
    combinedFonts = Object.entries(combinedFonts)
      .sort(([a], [b]) => a.localeCompare(b))
      .reduce((r, [key, v]) => ({ ...r, [key]: v }), {});
  }
  const fontWithStyle = fontStyleValue
    ? `${fontPropertyValue}-${fontStyleValue}`
    : fontPropertyValue;
  let getFontFamilyValue = Object.keys(combinedFonts).find((key: string) => {
    const value = combinedFonts[key as keyof typeof combinedFonts];
    if (value === fontWithStyle) return true;
    if (value === fontPropertyValue) return true;
    if (value === `${fontPropertyValue}-normal`) return true;
    if (value === `${fontPropertyValue}-italic`) return false;
    return false;
  });
  const fontPropertyHandler = (value: string) => {
    let fontStyle: {} = {};
    let fontCustomStyle: {} = {};

    switch (componentType) {
      case 'Font Family':
        const type = isItalicOrNormal(value);
        const fontFamilyValue = value.replace(/-(italic|normal)$/i, '').trim();
        fontStyle = {
          fontFamily: fontFamilyValue,
        };
        fontCustomStyle = type ? { fontStyle: type } : {};
        break;
      case 'Font Size':
      case 'Size':
        fontStyle = {
          fontSize: value,
        };
        break;
      case 'Font Weight':
        fontStyle = {
          fontWeight: value,
        };
        break;
      case 'Type':
        fontStyle = {
          btnType: value,
        };
        break;
      case 'Separator size':
        fontStyle = {
          separatorWidth: value,
        };
        break;
      case 'No of cards in a row':
        fontStyle = {
          noOfCard: value,
        };
        break;
      case 'Number of layouts in a row':
        fontStyle = {
          noOfLayout: value,
        };
        break;
      case 'Icon Size':
        fontStyle = {
          iconSize: value,
        };
        break;
    }
    setFontProperty(fontStyle);
    if (setFontStyle) setFontStyle(fontCustomStyle);
  };
  return (
    <Form.Group data-testid={`${componentType}-handler`}>
      <Form.Label className='design-section-sub-text'>{componentType}</Form.Label>
      <DropDownComponent
        setSelectedOption={fontPropertyHandler}
        selectedOption={
          componentType === 'Font Family' ? (getFontFamilyValue as string) : fontPropertyValue
        }
        className='lint-customize-dropdown'
        optionCollection={componentType === 'Font Family' ? combinedFonts : options}
        type={componentType}
      />
    </Form.Group>
  );
};

export default FontHandlerComponent;
